import { object, array, collection, number } from '@gogame/schemas';

import { PERIOD, APPLICATION, APPLICATION_SPEND, SPEND } from './constants';

export const applicationSpendSchema = object({
  [APPLICATION]: number().required('Application is required'),
  [SPEND]: number()
    .min(0, 'Spend must be more then 0')
    .required('Spend is required'),
}).default({});

export const mainBudgetPlanningSchema = object({
  [PERIOD]: array().required('Period is required'),
  [APPLICATION_SPEND]: collection(applicationSpendSchema).default([
    applicationSpendSchema.default(),
  ]),
});
